import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

export const FloatingHelpButton = () => {
    const {t} = useTranslation();

    const handleDownload = () => {
        toast.success(t('help.downloading'));
        const link = document.createElement('a');
        link.href = '/manuals/Handleiding Planningstool Projects in Care.pdf';
        link.download = 'Handleiding Planningstool Projects in Care.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <button
            onClick={handleDownload}
            className="fixed bottom-6 right-6 w-14 h-14 rounded-full border-2 border-primary bg-white text-primary hover:bg-primary hover:text-white transition-all duration-300 shadow-lg flex items-center justify-center z-50"
            title={t('help.download_button')}
        >
            <FontAwesomeIcon icon={faQuestionCircle} className="text-2xl" />
        </button>
    );
};

